import { Reducer } from 'redux';

import { LoadAzureVideoStreamUrlAction } from '../../domains/azureVideoStreamUrls/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import { AzureVideoStreamUrls } from './types';

export type AzureVideoStreamUrlAction = LoadAzureVideoStreamUrlAction;

const initialState: AzureVideoStreamUrls = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<AzureVideoStreamUrls, AzureVideoStreamUrlAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'AZURE_VIDEO_STREAM_URL.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'AZURE_VIDEO_STREAM_URL.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'AZURE_VIDEO_STREAM_URL.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.azureVideoStreamUrls);
    default:
      return state;
  }
};

export default reducer;
